import { EntityTypes } from "../../EntityTypes";
import { ITagResource } from "../../tags";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { ICategoryResource } from "../types";

export type ICategoryUpdateMutationParameters = {
    data: Partial<Pick<ICategoryResource, "title">> & {
        tags?: RelationalValue<ITagResource>[];
    };
    category: RelationalValue<ICategoryResource>;
};

export type ICategoryUpdateMutationResult = ICategoryResource;

export const categoryUpdateMutation: IApiMutationFunction<ICategoryUpdateMutationParameters> = ({ category, data }) => {
    return {
        method: "PUT",
        url: `/categories/${mapRelationalValue(category)}`,
        data: {
            ...data,
            tags: data.tags?.map(tag => mapRelationalValueAsIRI(EntityTypes.TAG, tag)),
        },
    };
};

export const useCategoryUpdateMutation = createApiMutationHook<
    ICategoryUpdateMutationParameters,
    ICategoryUpdateMutationResult
>(categoryUpdateMutation);
